(function () {
  var html = document.documentElement;
  var header = document.querySelector('[data-hdr]');
  var still = html.classList.contains('no-motion');
  var editor = html.classList.contains('is-editor');

  /* ---------- full-screen menu ---------- */
  var toggle = document.querySelector('[data-menu-toggle]');
  var menu = document.querySelector('[data-menu]');
  if (toggle && menu) {
    var label = toggle.querySelector('[data-menu-label]');
    var setMenu = function (open) {
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      menu.classList.toggle('is-open', open);
      if (header) header.classList.toggle('is-menu', open);
      document.body.classList.toggle('is-locked', open);
      if (label) label.textContent = label.getAttribute(open ? 'data-label-close' : 'data-label-open');
      if (window.__lenis) {
        if (open) window.__lenis.stop();
        else window.__lenis.start();
      }
    };
    toggle.addEventListener('click', function () {
      setMenu(toggle.getAttribute('aria-expanded') !== 'true');
    });
    menu.addEventListener('click', function (e) {
      if (e.target.closest('a')) setMenu(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.classList.contains('is-open')) {
        setMenu(false);
        toggle.focus();
      }
    });
  }

  /* ---------- dialogs ---------- */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open]');
    if (opener) {
      var d = document.getElementById(opener.getAttribute('data-open'));
      if (d && d.showModal) {
        d.showModal();
        if (window.__lenis) window.__lenis.stop();
      }
      return;
    }
    var closer = e.target.closest('[data-close]');
    if (closer) {
      var dd = closer.closest('dialog');
      if (dd) {
        dd.close();
        if (window.__lenis) window.__lenis.start();
      }
      return;
    }
    if (e.target.tagName === 'DIALOG') e.target.close();
  });
  [].forEach.call(document.querySelectorAll('dialog'), function (d) {
    d.addEventListener('close', function () {
      if (window.__lenis) window.__lenis.start();
    });
  });

  /* ---------- page curtain: the halves close before leaving, part on arrival ---------- */
  var curtain = document.querySelector('[data-curtain]');
  if (curtain && !still && !editor) {
    if (html.classList.contains('curtain-in')) {
      setTimeout(function () { html.classList.remove('curtain-in'); }, 1300);
    }
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest('a[href]');
      if (!a || a.hasAttribute('download') || a.hasAttribute('data-no-curtain')) return;
      if (a.target && a.target !== '_self') return;
      var url;
      try { url = new URL(a.href, window.location.href); } catch (err) { return; }
      if (url.origin !== window.location.origin) return;
      if (url.pathname === window.location.pathname && url.search === window.location.search) return;
      if (/^\/(checkout|cart\/(add|change|clear|update))/.test(url.pathname)) return;
      e.preventDefault();
      curtain.classList.add('is-closing');
      try { sessionStorage.setItem('cs-curtain', '1'); } catch (err) {}
      setTimeout(function () { window.location.href = url.href; }, 620);
    });
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) curtain.classList.remove('is-closing');
    });
  }

  /* ---------- bag ---------- */
  var bag = document.querySelector('[data-bag-form]');
  if (bag) {
    var updateUrl = bag.getAttribute('data-update-url') + '.js';
    var bagError = bag.querySelector('[data-bag-error]');
    var send = function (updates, fallback) {
      bag.classList.add('is-busy');
      fetch(updateUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
        .then(function (r) {
          if (!r.ok) throw new Error();
          window.location.reload();
        })
        .catch(function () {
          bag.classList.remove('is-busy');
          if (fallback) {
            window.location.href = fallback;
            return;
          }
          if (bagError) bagError.hidden = false;
        });
    };
    [].forEach.call(bag.querySelectorAll('[data-qty]'), function (s) {
      s.addEventListener('change', function () {
        var q = parseInt(s.value, 10) || 0;
        var updates = {};
        updates[s.getAttribute('data-key')] = q;
        var extra = s.getAttribute('data-extra-key');
        if (extra) updates[extra] = q * (parseInt(s.getAttribute('data-extra-per'), 10) || 1);
        send(updates);
      });
    });
    [].forEach.call(bag.querySelectorAll('[data-extra-key][data-remove]'), function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var updates = {};
        updates[a.getAttribute('data-remove')] = 0;
        updates[a.getAttribute('data-extra-key')] = 0;
        send(updates, a.href);
      });
    });
  }
})();
